import React, { Component } from 'react';
import documentData from '../../constants/documentType.json'
import Document from '../shared/document/Document';
import PageInfo from '../shared/pageInfo/PageInfo';

class Technical extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const techIcon = process.env.BASE_URL + "images/app/technical.png";
        var technicalData = documentData.filter(document => document.folderName == "Technical")[0];
        var documents = technicalData.files.map(file => {
            return <Document DocName={file.name} key={file.id} path={file.path} type={file.downloadType} />
        })
        return (
            <div className="mainBoxContent">
                <PageInfo pageTitle={technicalData.title} pageContent={technicalData.content} imgIcon={techIcon} />
        <div className="docContainer">
                    {documents}
                </div>
            </div >
        )
    }
}

export default Technical;